const menuItems = {
    items: [
        {
            id: 'navigation',
            title: 'Menu',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/dashboard',
                    icon: 'feather icon-home'
                },
                {
                    id: 'patients',
                    title: 'Patients',
                    type: 'item',
                    url: '/patients',
                    icon: 'feather icon-users'
                },
                {
                    id: 'schedule',
                    title: 'Schedule',
                    type: 'item',
                    url: '/schedule',
                    icon: 'feather icon-calendar'
                },
                {
                    id: 'timings',
                    title: 'Timings',
                    type: 'item',
                    url: '/timings',
                    icon: 'feather icon-calendar'
                },
                {
                    id: 'tasks',
                    title: 'Tasks',
                    type: 'item',
                    url: '/tasks',
                    icon: 'feather icon-list'
                },
            ]
        }
    ]
};

export default menuItems;
